import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  ON_BOARDING_DELETE_CUSTOM_FONT_BEGIN,
  ON_BOARDING_DELETE_CUSTOM_FONT_SUCCESS,
  ON_BOARDING_DELETE_CUSTOM_FONT_FAILURE,
  ON_BOARDING_DELETE_CUSTOM_FONT_DISMISS_ERROR,
} from './constants';
import { toast } from 'react-toastify';

export function deleteCustomFont(args = {}) {
  return (dispatch) => {
    dispatch({
      type: ON_BOARDING_DELETE_CUSTOM_FONT_BEGIN,
    });
    const { projectId, version, fontUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const URL = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-fonts/${fontUuid}`;
      const doRequest = axios.delete(URL, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: ON_BOARDING_DELETE_CUSTOM_FONT_SUCCESS,
            data: res.data.customFonts,
          });
          toast.success('Font Uninstalled Successfully');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: ON_BOARDING_DELETE_CUSTOM_FONT_FAILURE,
            data: { error: err },
          });
          toast.error('Failed to Uninstall Font');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCustomFontError() {
  return {
    type: ON_BOARDING_DELETE_CUSTOM_FONT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ON_BOARDING_DELETE_CUSTOM_FONT_BEGIN:
      return {
        ...state,
        deleteCustomFontPending: true,
        deleteCustomFontError: null,
      };

    case ON_BOARDING_DELETE_CUSTOM_FONT_SUCCESS:
      return {
        ...state,
        deleteCustomFontPending: false,
        deleteCustomFontError: null,
        customFontsList: action.data,
      };

    case ON_BOARDING_DELETE_CUSTOM_FONT_FAILURE:
      return {
        ...state,
        deleteCustomFontPending: false,
        deleteCustomFontError: action.data.error,
      };

    case ON_BOARDING_DELETE_CUSTOM_FONT_DISMISS_ERROR:
      return {
        ...state,
        deleteCustomFontError: null,
      };

    default:
      return state;
  }
}
